import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cx } from './cx';

/**
 * Notification banner (GOV.UK pattern; not part of ID-SK 2.11) in the ID-SK visual language.
 * Rendered as a polite status region; it never steals focus from the page heading.
 */
export function NotificationBanner({ type = 'info', title, children }: { type?: 'info' | 'success' | 'error'; title?: string; children: ReactNode }) {
  const { t } = useTranslation();
  const heading = title ?? (type === 'success' ? t('notification.success') : type === 'error' ? t('notification.error') : t('notification.important'));
  return (
    <div className={cx('app-notification-banner', type !== 'info' && `app-notification-banner--${type}`)} role={type === 'error' ? 'alert' : 'status'} aria-labelledby="notification-banner-title">
      <div className="app-notification-banner__header">
        <h2 className="app-notification-banner__title" id="notification-banner-title">
          {heading}
        </h2>
      </div>
      <div className="app-notification-banner__content">
        <div className="app-notification-banner__heading">{children}</div>
      </div>
    </div>
  );
}
